export default {
  retrieveSettingInfo (state, payload) {
    state.settingInfo = payload.settingInfo
    state.systemInfo.name = payload.settingInfo.system_name
  },

  retrieveSystemInfo (state, payload) {
    state.systemInfo = payload.systemInfo
  },
}
